<template>
    <div class="user-table-container">
        <div class="HeaderTop">
            <div class="SearchHead">
                <el-input size="medium" placeholder="搜索" v-model="SearchVal" @keyup.enter.native="ReSetPage">
                    <i slot="suffix" class="el-input__icon el-icon-search" @click="ReSetPage"></i>
                </el-input>
            </div>
            <div class="BtnHead">
                <el-button v-throttle class="BgColor" size="small" type="primary" @click="ToggleDig('Add')">新增角色</el-button>
            </div>
        </div>
        <el-table :data="Data" border stripe style="width: 100%;" class="custom-header-table" v-loading="loading" :tree-props="{children: 'children'}" default-expand-all row-key="id">
            <el-table-column prop="name" label="角色名称" min-width="100"></el-table-column>
            <el-table-column prop="code" label="角色编码" min-width="100"></el-table-column>
            <el-table-column prop="remark" label="角色说明" min-width="100"></el-table-column>
            <el-table-column prop="status" label="状态" min-width="100">
                <template slot-scope="scope">
                    <el-tag type="success" v-if="scope.row.status==1">开启</el-tag>
                    <el-tag type="info" v-else>关闭</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="create_time" label="创建时间" min-width="100"></el-table-column>
            <el-table-column label="操作" min-width="120" align="center">
                <template slot-scope="scope" v-if="scope.row.id !=1">
                    <i class="NavIcon el-icon-s-operation"@click="ToggleMenu(scope.row)"></i>
                    <el-tooltip effect="dark" content="编辑" placement="top-start">
                        <i class="NavIcon el-icon-edit"@click="ToggleDig(scope.row)"></i>
                    </el-tooltip>
                    <el-tooltip effect="dark" content="删除" placement="top-start">                        <i class="NavIcon el-icon-delete" @click="Delete(scope.row.id)"></i>                    </el-tooltip>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination background @size-change="SizeChange" @current-change="PageChange" :current-page="Page" 
            layout="total,prev,pager,next,sizes"
            :total="Totol" hide-on-single-page>
        </el-pagination>
        <el-dialog :title="Type=='Add'?'新增角色':'修改角色'" :visible.sync="NewData.NewBlon" width="25%" class="BorderRadius">
            <div class="DigItem">
                <div class="DigItemTit">角色名称：</div>
                <el-input class="Wid" size="medium" placeholder="请输入角色名称" v-model="NewData.name"></el-input>
            </div>
            <div class="DigItem">
                <div class="DigItemTit">角色说明：</div>
                <el-input class="Wid" size="medium" type="textarea" :rows="2" placeholder="请输入角色说明" v-model="NewData.remark"></el-input>
            </div>
            <div class="DigItem">
                <div class="DigItemTit">角色编码：</div>
                <el-input class="Wid" size="medium" placeholder="请输入角色编码" v-model="NewData.code"></el-input>
            </div>
            <div class="DigItem">
                <div class="DigItemTit">状态：</div>
                <el-switch class="Wid" v-model="NewData.status" active-color="#13ce66" inactive-color="#ddd" 
                    :active-value="1" :inactive-value="0"/>
            </div>
            <div slot="footer">
                <el-button v-throttle size="small" @click="$Tools.ResetData(NewData)">取消</el-button>
                <el-button v-throttle class="BgColor" size="small" type="primary" @click="Suc">确定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="菜单选择" :visible.sync="MenuData.MenuBlon" width="25%" class="BorderRadius">
            <div class="DigItem NoFlex">
                <div class="DigItemTit MarBom">分配菜单：</div>
                <el-checkbox-group size="medium" v-model="MenuData.MenuIds" @change="ChangeMenu">
                    <el-checkbox class="MarBom" v-for="item in MenuList" :label="item.id" :key="item.id">{{item.title}}</el-checkbox>
                  </el-checkbox-group>
            </div>
            <div slot="footer">
                <el-button v-throttle size="small" @click="$Tools.ResetData(MenuData)">取消</el-button>
                <el-button v-throttle class="BgColor" size="small" type="primary" @click="SucMenu">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "AdminIndex",
        data() {
            return {
                loading:false,
                SearchVal:"",
                Data: [],
                Page:1,
                PageSize:10,
                Totol:0,
                Type:'Add',
                NewData:{
                    id:'',
                    NewBlon:false,
                    name:"",
                    code:"",
                    remark:"",
                    status:false,
                },
                MenuList:"",
                MenuData:{
                    id:"",
                    MenuBlon:false,
                    MenuIds:[],
                }
            };
        },
        mounted() {
            this.GetData();
            this.GetMenu();
        },
        methods: {
            GetData(){
                this.loading = true;
                this.$get('/admin/role/index',{
                    keyword:this.SearchVal,
                    page:this.Page,
                    page_size:this.PageSize,
                }).then(res=>{
                    this.loading = false;
                    if(res){
                        this.Data = res.data;
                        // this.Totol = res.data.total;
                    }
                })
            },
            GetMenu(){
                this.$get('/admin/menu/index').then(res=>{
                    if(res){
                        this.MenuList = res.data;
                    }
                })
            },
            ToggleMenu(row){
                this.MenuData.id = row.id;
                this.MenuData.MenuBlon = true;
                this.MenuData.MenuIds = row.menu_ids;
            },
            ChangeMenu(i){
                this.MenuData.MenuIds = i;
            },
            SucMenu(){
                if(this.MenuData.MenuIds.length ==0){
                    this.$message.error("请选择菜单");
                    return 
                }
                this.$post('/admin/role/assignMenus/'+this.MenuData.id,{
                    menu_ids:this.MenuData.MenuIds,
                }).then(res=>{
                    if(res){
                        this.$message.success(res.msg);
                        this.GetData();
                        this.$Tools.ResetData(this.MenuData)
                    }
                })
            },
            ToggleDig(row){
                this.$Tools.ResetData(this.NewData)
                if(row!='Add'){
                    this.Type='Edi';
                    this.NewData.id = row.id;
                    this.NewData.name = row.name;
                    this.NewData.code = row.code;
                    this.NewData.remark = row.remark;
                    this.NewData.status = row.status;
                }else{
                    this.Type='Add';
                }
                this.NewData.NewBlon = true;
            },
            Suc(){
                if(this.Type=='Add'){
                    this.SucNew();
                }else{
                    this.SucEdit();
                }
                this.$Tools.ResetData(this.NewData)
            },
            SucEdit(){
                this.$put('/admin/role/update/'+this.NewData.id,{
                    "name": this.NewData.name,
                    "code": this.NewData.code,
                    "remark": this.NewData.remark,
                    "status": this.NewData.status,
                }).then(res=>{
                    if(res){
                        this.$message.success("修改成功");
                        this.GetData();
                    }
                })
            },
            SucNew(row) {
                this.$post('/admin/role/save',{
                    "name": this.NewData.name,
                    "code": this.NewData.code,
                    "remark": this.NewData.remark,
                    "status": this.NewData.status,
                    "parent_id":0,
                }).then(res=>{
                    if(res){
                        this.$message.success("添加成功");
                        this.ReSetPage();
                    }
                })
            },
            Delete(id) {
                this.$confirm("此操作将永久删除该角色, 是否继续?", "提示", {
                    type: "warning"
                }).then(() => {
                    this.$del('/admin/role/delete/'+id).then(res=>{
                        if(res){
                            this.$message.success("删除成功!");
                            this.GetData();
                        }
                    })
                })
            },
            SizeChange(val){
                this.PageSize = val;
                this.GetData();
            },
            PageChange(val){
                this.Page = val;
                this.GetData();
            },
            ReSetPage(){
                this.Page = 1;
                this.GetData();
            },
        }
    };
</script>

<style scoped>
    
</style>
